import { apiClient } from '@/lib/api/client';
import type {
  BranchListResponse,
  Deal,
  DealCreateInput,
  DealListResponse,
  DealListParams,
  DealProductListResponse,
  DealProductLookupParams,
  DealPatchInput,
} from './types';

export async function listDeals(params: DealListParams = {}): Promise<DealListResponse> {
  const { data } = await apiClient.get<DealListResponse>('/merchant/deals', { params });
  return data;
}

export async function createDeal(body: DealCreateInput): Promise<Deal> {
  const { data } = await apiClient.post<Deal>('/merchant/deals', body);
  return data;
}

export async function patchDeal(dealId: string, body: DealPatchInput): Promise<Deal> {
  const { data } = await apiClient.patch<Deal>(`/merchant/deals/${dealId}`, body);
  return data;
}

export async function endDeal(dealId: string): Promise<Deal> {
  const { data } = await apiClient.post<Deal>(`/merchant/deals/${dealId}/end`);
  return data;
}

export async function cancelDeal(dealId: string): Promise<Deal> {
  const { data } = await apiClient.delete<Deal>(`/merchant/deals/${dealId}`);
  return data;
}

export async function listBranches(): Promise<BranchListResponse> {
  const { data } = await apiClient.get<BranchListResponse>('/merchant/branches');
  return data;
}

export async function listDealProducts(
  params: DealProductLookupParams = {},
): Promise<DealProductListResponse> {
  const { data } = await apiClient.get<DealProductListResponse>('/merchant/products', { params });
  return data;
}
